import Phaser, {
    Display
} from 'phaser'

let utils;
let background;
let midground;
let foreground;
let widthBounds;
let heightBounds;
let gameScale;
let world;

export default class WorldGraphics extends Phaser.Scene {
    constructor() {
        super('worldGraphics')
    }

    init(data) {
        gameScale = this.registry.values.scaleIt;
        background = data.background;
        foreground = data.foreground;
        midground = data.midground;
        widthBounds = data.widthBounds;
        heightBounds = data.heightBounds;
    }

    create() {
        utils = this.scene.get('utils');
        world = this.scene.get('world');
        this.addBackground();
        this.addMidground();
        this.addKaumatua();
        this.addForeGround();
    }
    addForeGround() {
        foreground.add(utils.addImage(world, {
            x: 200,
            y: 475,
            id: 'redGrass'
        }));

        foreground.add(utils.addImage(world, {
            x: -450,
            y: 300,
            id: 'flax1'
        }));


        foreground.add(utils.addImage(world, {
            x: 600,
            y: 500,
            id: 'flax2'
        }));

        foreground.add(utils.addImage(world, {
            x: 1300,
            y: 650,
            flip: true,
            scale: 0.6,
            id: 'flax2'
        }));

        foreground.add(utils.addImage(world, {
            x: 2200,
            y: 450,

            id: 'flax2'
        }));

        foreground.add(utils.addImage(world, {
            x: 3000,
            y: 750,
            flip: true,
            scale: 0.8,
            id: 'redGrass'
        }));

        foreground.add(utils.addImage(world, {
            x: 4000,
            y: 450,
            flip: true,
            scale: 0.8,
            id: 'flax1'
        }));
    }

    addMidground() {

        let arr = new Array;
        let hitFlax1 = [
            [129, 1116],
            [245, 465],
            [458, 13],
            [796, 457],
            [938, 1089]
        ];
        let hitFlax2 = [
            [183, 1077],
            [198, 469],
            [515, 31],
            [926, 554],
            [856, 1077]
        ];
        let hitCabbage1 = [
            [117, 699],
            [177, 382],
            [137, 420],
            [56, 265],
            [18, 77],
            [211, 21],
            [323, 105],
            [312, 186],
            [234, 204],
            [223, 318],
            [279, 293],
            [285, 396],
            [207, 471],
            [258, 709]
        ];
        let hitCabbage2 = [
            [93, 460],
            [91, 190],
            [50, 204],
            [25, 56],
            [91, 13],
            [207, 93],
            [206, 153],
            [243, 133],
            [229, 273],
            [162, 462]
        ];
        let hitCabbage3 = [
            [102, 477],
            [128, 289],
            [121, 210],
            [51, 190],
            [47, 115],
            [189, 0],
            [251, 69],
            [144, 200],
            [174, 484]
        ];
        let hitKawakawa = [
            [164, 401],
            [12, 378],
            [25, 165],
            [215, 11],
            [296, 56],
            [224, 234],
            [295, 230],
            [313, 383]
        ];
        /*** HILLS */


        arr.push({
            x: 3265,
            y: 214,
            id: 'worldMidground3',
            english: 'beach',
            maori: 'one',
            hit: [
                [39, 141],
                [267, 29],
                [553, 47],
                [544, 486]
            ]
        });
        arr.push({
            x: 3055,
            y: 225,
            id: 'midGround3Sea',
            english: 'sea',
            maori: 'moana',
            hit: [
                [1, 6],
                [505, 14],
                [505, 56],
                [260, 119]
            ]
        });

        arr.push({
            x: -50,
            y: 215,
            id: 'sea',
            english: 'sea',
            maori: 'moana',
            hit: [
                [0, 155],
                [0, 0],
                [564, 2],
                [1420, 27],
                [1422, 80],
                [1725, 92],
                [1730, 158],
                [1522, 146],
                [1086, 205],
                [573, 205]
            ]
        });
        arr.push({
            x: -50,
            y: 407,
            id: 'river',
            english: 'river',
            maori: 'awa',
            hit: [
                [0, 473],
                [0, 233],
                [762, 33],

                [849, 6],
                [851, 70],
                [467, 472]
            ]
        });
        arr.push({
            x: -50,
            y: 183,
            id: 'worldMidground2',
            english: 'beach',
            maori: 'one',
            hit: [
                [0, 462],
                [0, 396],
                [210, 333],
                [477, 289],
                [365, 218],
                [766, 242],
                [774, 262],
                [564, 325],
                [319, 350]
            ]
        });


        arr.push({
            x: 405,
            y: 0,
            id: 'worldMidgroundHill1',

            english: 'land',
            maori: 'whenua',
            hit: [
                [13, 878],
                [158, 669],
                [414, 460],
                [392, 394],
                [1227, 361],
                [1267, 311],
                [894, 295],
                [978, 240],
                [579, 227],
                [600, 198],
                [936, 130],
                [1084, 103],
                [1385, 8],
                [1577, 56],
                [1619, 27],
                [2022, 69],
                [2212, 1],
                [2376, 31],
                [2701, 250],
                [2878, 297],
                [2950, 363],
                [3302, 482],
                [3451, 663],
                [3448, 877]
            ]
        });

        arr.push({
            x: 1456,
            y: 0,
            id: 'worldMidgroundHill2'
        });

        arr.push({
            x: 2456,
            y: 0,
            id: 'worldMidgroundHill3'
        });

        /*** RIVER  ***/
        arr.push({
            x: 52,
            y: 310,
            id: 'flax2',
            scale: 0.15,
            english: 'mountain / coastal flax',
            maori: 'wharariki',
            hit: hitFlax2
        });
        arr.push({
            x: 212,
            y: 250,
            id: 'cabbage2',
            scale: 0.43,
            flip: true,
            english: 'cabbage tree',
            maori: 'tī kōuka',
            hit: hitCabbage2
        });
        arr.push({
            x: 225,
            y: 325,
            id: 'kawakawa',
            scale: 0.3,
            english: 'peppertree',
            maori: 'kawakawa',
            hit: hitKawakawa
        });
        arr.push({
            x: 796,
            y: 218,
            id: 'raupo',
            english: 'bullrush',
            maori: 'raupō',
            hit: [
                [31, 189],
                [23, 125],
                [56, 9],
                [251, 55],
                [249, 182]
            ],
            location: 'raupo'
        });

        arr.push({
            x: 1111,
            y: 116,
            id: 'cabbage1',
            scale: 0.42,
            english: 'cabbage tree',
            maori: 'tī kōuka',
            hit: hitCabbage1
        });


        /*** WHARENUI */
        arr.push({
            x: 1106,
            y: 167,
            id: 'wharenui',
            english: 'meeting house',
            maori: 'wharenui',
            hit: [
                [51, 339],
                [59, 246],
                [5, 248],
                [210, 87],
                [232, 2],
                [259, 93],
                [390, 133],
                [495, 205],
                [480, 208],
                [490, 268],
                [413, 337]
            ],
            location: 'wharenui'
        });
        /***GROUP ***/
        arr.push({
            x: 1518,
            y: -20,
            id: 'cabbage1',
            flip: true,
            english: 'cabbage tree',
            maori: 'tī kōuka',
            hit: hitCabbage1
        });
        arr.push({
            x: 1657,
            y: 247,
            id: 'cabbage2',
            english: 'cabbage tree',
            maori: 'tī kōuka',
            hit: hitCabbage2
        });
        arr.push({
            x: 1565,
            y: 350,
            id: 'kawakawa',
            english: 'peppertree',
            maori: 'kawakawa',
            hit: hitKawakawa,
            location: 'kawakawa'
        });

        /*** KAUMATUA */
        arr.push({
            x: 1951,
            y: 164,
            id: 'flax1',
            scale: 0.27,
            english: 'flax',
            maori: 'harakeke',
            hit: hitFlax1
        });
        arr.push({
            x: 2080,
            y: 12,
            id: 'manuka3',
            english: 'tea tree',
            maori: 'mānuka',
            hit: [
                [18, 153],
                [33, 87],
                [217, 32],
                [455, 0],
                [490, 15],
                [486, 57],
                [412, 63],
                [380, 115]
            ],
            location: 'manuka'
        });

        arr.push({
            x: 2060,
            y: 374,
            id: 'flax1',
            scale: 0.27,
            flip: true,
            english: 'flax',
            maori: 'harakeke',
            hit: hitFlax1
        });
        arr.push({
            x: 2313,
            y: 380,
            id: 'redGrass',
            scale: 0.25
        });



        /*** BEFORE AUNTY */
        arr.push({
            x: 2717,
            y: 20,
            id: 'cabbage2',
            scale: 0.44,
            english: 'cabbage tree',
            maori: 'tī kōuka',
            hit: hitCabbage2
        });
        arr.push({
            x: 2670,
            y: -50,
            id: 'cabbage1',
            scale: 0.39,
            flip: true,
            english: 'cabbage tree',
            maori: 'tī kōuka',
            hit: hitCabbage1
        });

        arr.push({
            x: 2638,
            y: 100,
            id: 'cabbage3',
            scale: 0.31,
            english: 'cabbage tree',
            maori: 'tī kōuka',
            hit: hitCabbage3
        });
        arr.push({
            x: 2884,
            y: 85,
            id: 'manuka2',

            english: 'tea tree',
            maori: 'mānuka',
            hit: [
                [21, 163],
                [58, 42],
                [233, 3],
                [295, 52],
                [111, 118],
                [67, 114],
                [60, 166]
            ],
            location: 'manuka'
        });
        arr.push({
            x: 2625,
            y: 253,
            id: 'flax2',
            scale: 0.21,
            english: 'mountain / coastal flax',
            maori: 'wharariki',
            hit: hitFlax2
        });
        arr.push({
            x: 2770,
            y: 333,
            id: 'flax2',
            scale: 0.15,
            flip: true,
            english: 'mountain / coastal flax',
            maori: 'wharariki',
            hit: hitFlax2
        });
        arr.push({
            x: 2514,
            y: 371,
            id: 'flax1',
            scale: 0.23,

            english: 'flax',
            maori: 'harakeke',
            hit: hitFlax1
        });
        arr.push({
            x: 3373,
            y: 190,
            id: 'manuka1',
            english: 'tea tree',
            maori: 'mānuka',
            hit: [
                [63, 268],
                [33, 153],
                [0, 139],
                [49, 77],
                [131, 28],
                [242, 7],
                [278, 52],
                [226, 103],
                [279, 156],
                [108, 172],
                [100, 271]
            ]
        });

        /*** BEHIND AUNTY */
        arr.push({
            x: 2880,
            y: 411,
            id: 'flax1',
            scale: 0.19,

            english: 'flax',
            maori: 'harakeke',
            hit: hitFlax1
        });
        arr.push({
            x: 3111,
            y: 386,
            id: 'flax1',
            scale: 0.23,

            english: 'flax',
            maori: 'harakeke',
            hit: hitFlax1
        });

        arr.push({
            x: 3180,
            y: 460,
            id: 'flax1',
            scale: 0.29,
            flip: true,

            english: 'flax',
            maori: 'harakeke',
            hit: hitFlax1
        });
        arr.push({
            x: 3013,
            y: 168,
            id: 'cabbage3',
            english: 'cabbage tree',
            maori: 'tī kōuka',
            hit: hitCabbage3
        });
        arr.push({
            x: 3015,
            y: 405,
            id: 'cabbage2',
            scale: 0.6,
            flip: true,
            english: 'cabbage tree',
            maori: 'tī kōuka',
            hit: hitCabbage2
        });
        arr.push({
            x: 3080,
            y: 590,
            id: 'redGrass',
            scale: 0.18
        })
        arr.push({
            x: 2950,
            y: 625,
            id: 'flaxBundle',
            scale: 0.12

        });
        arr.push({
            x: 3098,
            y: 605,
            id: 'auntyKewa',
            scale: 0.36,
            english: 'Aunty Kewa',
            location: 'auntyKewa',
            hit: [
                [131, 541],
                [75, 241],
                [147, 7],
                [203, 0],
                [259, 90],
                [296, 320],
                [247, 465]
            ]

        });

        arr.push({
            x: 3000,
            y: 700,
            id: 'flaxBundle',
            scale: 0.18,
            rotation: 0.3
        });





        //Add everything to midground container

        for (let index = 0; index < arr.length; index++) {
            midground.add(utils.addImage(world, arr[index]));
        }



    }

    addKaumatua() {
        /**** KAUMATUA */
        let kaumatuaContainer = world.add.container(2250 * gameScale, 180 * gameScale);

        let k1 = utils.addImage(world, {
            id: 'kaumatuaPorch',
            y: 135
        });
        let k3 = utils.addImage(world, {
            y: -30,
            x: 630,
            scale: 0.7,
            id: 'kaumatuaPorch',
        });

        let k2 = utils.addImage(world, {
            scale: 0.8,
            x: 1350,
            y: -40,
            id: 'kaumatuaPorch',
        });
        k2.setCrop(0, 0, k2.width, k2.height - k2.height / 4);

        //Clone the image that was just clicked
        let imgClone = world.add.renderTexture(k2.x, k2.y, k2.width, k2.height);
        //draw the render of this image
        imgClone.draw(k2, 0, 0);
        imgClone.setTint(0x452a13);
        imgClone.alpha = 0.25;
        let imgClone3 = world.add.renderTexture(k3.x, k3.y, k3.width, k3.height);
        imgClone3.draw(k3, 0, 0);
        imgClone3.setTint(0x452a13);
        imgClone3.alpha = 0.5;

        let porchStep = utils.addImage(world, {
            id: 'porchStep',
            x: 1880,
            y: 800
        });

        let flax = utils.addImage(world, {
            scale: 0.58,
            x: 2200,
            y: 270,
            id: 'flax1'
        });
        let grass = utils.addImage(world, {
            scale: 0.58,
            x: 1730,
            y: 560,
            id: 'redGrass',
        });



        let n = utils.addImage(world, {
            id: 'nana',
            x: 456,
            y: 855
        });
        let u = utils.addImage(world, {
            id: 'nanaUnder',
            x: 618,
            y: 952
        });

        let b = utils.addImage(world, {
            id: 'nanaBottom',
            x: 485,
            y: 986
        });

        let hit = [
            [179, 1582],
            [163, 717],
            [1190, 74],
            [2299, 195],
            [2654, 515],
            [2595, 1108],
            [1575, 1102],
            [917, 1583],
        ];

        kaumatuaContainer.setData({
            english: 'village',
            maori: 'papakāinga',
            location: 'kaumatuaPorch',
            hit: hit
        });
        //kaumatuaContainer.setSize(k.displayWidth, k.displayHeight);

        kaumatuaContainer.add([k3, imgClone3, k2, imgClone, porchStep, grass, flax, k1, u, b, n]);
        //kaumatuaContainer.setScale(0.12);
        kaumatuaContainer.setScale(0.12);


        midground.add(kaumatuaContainer);

    }

    addBackground() {
        //Repeat sky colour instead of one big buggy svg
        let worldbackgroundSky;
        let x = -50 * gameScale;
        do {
            worldbackgroundSky = utils.addImage(world, {
                x: x / gameScale,
                y: 0,
                id: 'worldBackgroundSky',
                english: 'sky',
                maori: 'rangi'
            });

            background.add(worldbackgroundSky);
            x = worldbackgroundSky.x + worldbackgroundSky.width - 5;
        }
        while (x < widthBounds * gameScale);

        //hold the current cloud image
        let cloud;
        //hold the random numbers
        let ran
        //Add 25 random clouds to background
        for (let index = 0; index < 25; index++) {

            ran = Math.ceil((Math.random() * 3));
            //cloud = this.add.image(0, 0, 'cloud' + ran).setOrigin(0, 0);
            cloud = utils.addImage(world, {
                id: 'cloud' + ran,
                english: 'clouds',
                maori: 'kapua'
            });
            //this.add.image(0, 0, 'cloud' + ran).setOrigin(0, 0);

            ran = Math.ceil((Math.random() * widthBounds * gameScale));
            cloud.x = ran;

            ran = Math.ceil((Math.random() * heightBounds / 1.5 * gameScale));
            cloud.y = ran;

            ran = Math.random() * 0.8 + 0.2;
            cloud.scale = ran;
            ran = Math.ceil((Math.random() * 4));
            switch (ran) {
                case 1:
                    cloud.setTint(0xf4f3f2);
                    break;
                case 2:
                    cloud.setTint(0xFFFFFF);
                    break;
                case 3:
                    cloud.setTint(0xFDFDE5);
                    break;
                default:
            }
            ran = Math.random() * 0.6 + 0.3;
            cloud.setAlpha(ran);
            ran = Math.ceil(Math.random() * 2);
            if (ran == 1) {
                cloud.flipX = true;
            }


            background.add(cloud);
        }
    }
}